import Skeleton from "../../common/Skeleton";

const WatchlistStatsSkeleton = () => {
  return (
    <>
      {/* Mobile Layout Skeleton */}
      <div className="block lg:hidden">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="flex items-start gap-2 space-x-3 bg-gray-100 dark:bg-gray-800/50 rounded-lg p-3 border border-gray-200 dark:border-gray-700/50"
            >
              <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <Skeleton className="w-24 h-4 rounded mb-2" />
                <Skeleton className="w-16 h-6 rounded mb-1" />
                <Skeleton className="w-20 h-3 rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop Layout Skeleton */}
      <div className="hidden lg:flex justify-between items-center border border-[#d0d4e4] rounded-md dark:border-0 bg-white my-0 !mt-0 dark:bg-[#121419] w-full shadow-[5px_1px_5px_rgba(0,0,0,0.09)] mb-2">
        <div className="flex items-center w-full py-4">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className={`flex items-center space-x-3 flex-1 ${index === 0 ? "px-4" : "px-6"} py-0 ${index !== 2 ? "border-r border-[#d0d4e4] dark:border-gray-700" : ""}`}
            >
              <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
              <div>
                <Skeleton className="w-24 h-4 rounded mb-1" />
                <Skeleton className="w-12 h-6 rounded mb-1" />
                <Skeleton className="w-20 h-3 rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WatchlistStatsSkeleton;
